import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button/Button';
import Icon from 'components/Icon';

import TrelloModalContainer from './TrelloModal.styled';

const TrelloModal = ({ closeTrelloGuide }) => (
  <TrelloModalContainer type="button" unstyled onClick={closeTrelloGuide}>
    <div className="container">
      <div className="banner asana" />
      <div className="content">
        <h2>
          <span className="icon">
            <Icon name="check" width="16px" fill="#fff" />
          </span>
          &nbsp;Asana integrated successfully!
        </h2>
        <p>
          You can now add your comments and edits to Asana by simply clicking on
          3 dots of comments and send the same to Asana.
        </p>
        <Button type="button" styled onClick={closeTrelloGuide}>
          Gotcha
        </Button>
      </div>
    </div>
  </TrelloModalContainer>
);

TrelloModal.propTypes = {
  closeTrelloGuide: PropTypes.func,
};

export default TrelloModal;
